export const mapBiologicalSexToCurpSex = (
	sex: string | undefined,
): 'male' | 'female' | 'other' => {
	const normalized = sex?.toUpperCase();
	if (normalized === 'HOMBRE') return 'male';
	if (normalized === 'MUJER') return 'female';
	return 'other';
};
